import {useMutation} from '@tanstack/react-query';
import {ACCOUNTS_TRANSACTION_TYPES} from 'constants/common';
import {useClient} from 'context/auth-context';
import {useNotification} from 'context/notification-context';
import {saveFile} from 'helpers/fileSaver';
import {BusinessPartner} from 'types/api';

export interface IUseGetExportFile {
    url: string;
    params?: Record<string, any>;
}

export interface IUseGetExportFileResponse {
    fileName: string;
    content: string;
    contentType?: string;
}

const useGetExportFile = () => {
    const client = useClient();

    return useMutation<IUseGetExportFileResponse, unknown, IUseGetExportFile>({
        mutationFn: ({url, params}) =>
            client(url, {
                params,
            }),
        onSuccess: data => {
            saveFile(data);
        },
    });
};

interface IUseExportZipRequest {
    businessPartner: string;
    from: string;
    to: string;
    card: string | null;
    wallet: string | null;
    type: (typeof ACCOUNTS_TRANSACTION_TYPES)[number]['@id'] | null;
}

const useExportZip = () => {
    const client = useClient();
    const {addNotification} = useNotification();

    return useMutation<unknown, unknown, IUseExportZipRequest>({
        mutationFn: data =>
            client('/web_api/transaction_zip_export_requests', {
                method: 'POST',
                data,
            }),
        onSuccess: () =>
            addNotification(
                {
                    area: 'zipExports',
                    status: 'success',
                    message: 'ZIP export will be sent to your email',
                },
                'zip_export',
            ),
        onError: (err: any) => {
            addNotification(
                {
                    area: 'zipExports',
                    status: 'error',
                    message:
                        err?.['hydra:description'] ||
                        'Something went wrong. If the issue persist, please contact our support.',
                },
                'zip_export',
            );
        },
    });
};

export {useGetExportFile, useExportZip};
